export default __webpack_public_path__ + "static/media/67-min.3fef3911.png";